module.exports = __webpack_public_path__ + "img/territorios-monitorados.15c25637.svg";